/**
 * Created by mac on 3/4/20
 */

const OpenCardsView = cc.Node.extend({
    ctor: function (openCards) {
        this._super();

        this.openCards = openCards;

        openCards.on("shift", this.shift.bind(this));
        openCards.on("pop", this.pop.bind(this));

        openCards.on("beforeReplace", this.beforeReplace.bind(this));
        openCards.on("replace", this.replace.bind(this));
        openCards.on("hidePrevious", this.hidePreviousCard.bind(this));

        this.openCards.cards.forEach((card, index) => {
            const ViewClass = card.getViewClass();
            const view = new ViewClass(card);
            view.setRotation(0);
            view.setLocalZOrder(index);
            this.addChild(view);
            view.visible = index === (this.openCards.cards.length - 1);
        });

        this.openCards.getView = function () {
            return this;
        }.bind(this);
    },

    findPosForCard: function () {
        return cc.p(0, 0);
    },

    hidePreviousCard: function (card) {
        const index = this.openCards.cards.indexOf(card);
        if (index > 0) {
            const view = this.openCards.cards[index - 1].onGetView();
            view.visible = false;
        }
    },

    pop: function () {
        const newTop = this.openCards.getCurrentCard();
        if (newTop) {
            const newTopView = newTop.onGetView();
            newTopView.setVisible(true);
        }
    },

    shift: function (card, lastTop, silent) {
        const cardView = card.onGetView();

        cardView.shiftToOpen(this, {
            zIndex: this.openCards.cards.length,
            callback: function () {
                if (lastTop) {
                    const lastTopView = lastTop.onGetView();
                    if (lastTop.inAnimation()) {
                        const movingNode = cleverapps.Scenes.GetMovingNode(cardView);
                        const realParent = cardView.parent;
                        cardView.replaceParentSamePlace(movingNode, {
                            keepScale: true
                        });
                        const leftTime = lastTop.animationEndTime - cleverapps.timeouts.getTime();
                        cleverapps.timeouts.setTimeout(() => {
                            cardView.replaceParentSamePlace(realParent, {
                                keepScale: true
                            });
                            lastTopView.setVisible(false);
                        }, leftTime);
                    } else {
                        lastTopView.setVisible(false);
                    }
                }
            },
            silent
        });
    },

    beforeReplace: function (newCard) {
        const ViewClass = newCard.getViewClass();
        const newView = new ViewClass(newCard);
        newView.setVisible(false);
        this.addChild(newView);
    },

    replace: function (oldCard, newCard) {
        const oldView = oldCard.onGetView();
        const newView = newCard.onGetView();

        const index = this.openCards.cards.indexOf(newCard);
        newView.setLocalZOrder(index + 1);
        if (index > 0) {
            const lastTop = this.openCards.cards[index - 1];
            lastTop.onGetView().setVisible(false);
        }

        oldView.removeFromParent();
        newView.setVisible(true);

        cleverapps.effects.fire("solitaire.trump.change");
    }
});